/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiStreemRoomCredentialsFromJSON, StreemApiStreemRoomCredentialsToJSON, } from './';
export function StreemApiCreateRoomTokenResponseFromJSON(json) {
    return StreemApiCreateRoomTokenResponseFromJSONTyped(json, false);
}
export function StreemApiCreateRoomTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'streemRoomCredentials': !exists(json, 'streem_room_credentials') ? undefined : StreemApiStreemRoomCredentialsFromJSON(json['streem_room_credentials']),
    };
}
export function StreemApiCreateRoomTokenResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'streem_room_credentials': StreemApiStreemRoomCredentialsToJSON(value.streemRoomCredentials),
    };
}
//# sourceMappingURL=StreemApiCreateRoomTokenResponse.js.map